<template>
    <b-modal centered ref="modal" hide-header-close>
        <template #modal-header>
            <div class="mx-auto">
                <h5 class="text-primary font-20 font-weight-bold">Enquiry Details</h5>
            </div>
        </template>
        <div>
            <div>
                <div class="d-flex align-items-center mb-3">
                    <i class="mdi mdi-car text-primary font-20 mr-2"></i>
                    <span
                        v-if="customerEnquiry.vehicle"
                        class="font-weight-bold font-14"
                        >
                        {{ customerEnquiry.vehicle.formatted_shortened_name }}
                    </span>
                </div>
                <div class="row">
                    <div class="col-6">
                        <label class="font-weight-bold">Name:</label>
                    </div>
                    <div class="col">
                        <span class="d-inline-block mw-100">{{ customerEnquiry.first_name + ' ' + customerEnquiry.last_name }}</span>
                    </div>
                </div>
                <div class="row">
                    <div class="col-6">
                        <label class="font-weight-bold">Email:</label>
                    </div>
                    <div class="col">
                        <span class="d-inline-block mw-100 email-span">{{ customerEnquiry.email }}</span>
                    </div>
                </div>
                <div class="row">
                    <div class="col-6">
                        <label class="font-weight-bold">Phone:</label>
                    </div>
                    <div class="col">
                        <span class="d-inline-block mw-100">{{ customerEnquiry.phone }}</span>
                    </div>
                </div>
                <div class="row">
                    <div class="col-6">
                        <label class="font-weight-bold">Monthly Budget:</label>
                    </div>
                    <div class="col">
                        <span class="d-inline-block mw-100">{{ customerEnquiry.monthly_budget }}</span>
                    </div>
                </div>
                <div class="row">
                    <div class="col-6">
                        <label class="font-weight-bold">Birthdate:</label>
                    </div>
                    <div class="col">
                        <span class="d-inline-block mw-100">{{ customerEnquiry.birth_date | local_date }}</span>
                    </div>
                </div>
                <div class="row">
                    <div class="col-6">
                        <label class="font-weight-bold">Employment Status:</label>
                    </div>
                    <div class="col">
                        <span class="d-inline-block mw-100">{{ customerEnquiry.employment_status }}</span>
                    </div>
                </div>
                <div class="row">
                    <div class="col-6">
                        <label class="font-weight-bold">Occupation:</label>
                    </div>
                    <div class="col">
                        <span class="d-inline-block mw-100">{{ customerEnquiry.occupation }}</span>
                    </div>
                </div>
                <div class="row">
                    <div class="col-6">
                        <label class="font-weight-bold">Working Student:</label>
                    </div>
                    <div class="col d-inline-block mw-100">
                        <span v-if="customerEnquiry.is_working_student === null || is_working_student === undefined">N/A</span>
                        <span v-else-if="customerEnquiry.is_working_student">Yes</span>
                        <span v-else>No</span>
                    </div>
                </div>
                <div class="row">
                    <div class="col-6">
                        <label class="font-weight-bold">Other Employment Status:</label>
                    </div>
                    <div class="col">
                        <span class="d-inline-block mw-100">{{ customerEnquiry.other_employment_status || 'N/A' }}</span>
                    </div>
                </div>
                <div class="row">
                    <div class="col-6">
                        <label class="font-weight-bold">Income Paid:</label>
                    </div>
                    <div class="col">
                        <span class="d-inline-block mw-100">{{ customerEnquiry.income_paid }}</span>
                    </div>
                </div>
                <div class="row">
                    <div class="col-6">
                        <label class="font-weight-bold">Income Amount:</label>
                    </div>
                    <div class="col">
                        <span class="d-inline-block mw-100">{{ customerEnquiry.income_amount }}</span>
                    </div>
                </div>
                <div class="row">
                    <div class="col-6">
                        <label class="font-weight-bold">Additional Income:</label>
                    </div>
                    <div class="col d-inline-block mw-100">
                        <span v-if="customerEnquiry.has_additional_income === null || customerEnquiry.has_additional_income === undefined">N/A</span>
                        <span v-else-if="value">Yes</span>
                        <span v-else>No</span>
                    </div>
                </div>
                <div class="row">
                    <div class="col-6">
                        <label class="font-weight-bold">Monthly Income:</label>
                    </div>
                    <div class="col">
                        <span class="d-inline-block mw-100">{{ customerEnquiry.monthly_income }}</span>
                    </div>
                </div>
                <div class="row">
                    <div class="col-6">
                        <label class="font-weight-bold">Employment Length:</label>
                    </div>
                    <div class="col">
                        <span class="d-inline-block mw-100">{{ customerEnquiry.employment_length }}</span>
                    </div>
                </div>
                <div class="row">
                    <div class="col-6">
                        <label class="font-weight-bold">Credit Score:</label>
                    </div>
                    <div class="col">
                        <span class="d-inline-block mw-100">{{ customerEnquiry.credit_score }}</span>
                    </div>
                </div>
                <div class="row">
                    <div class="col-6">
                        <label class="font-weight-bold">Address:</label>
                    </div>
                    <div class="col">
                        <span class="d-inline-block mw-100">{{ customerEnquiry.address }}</span>
                    </div>
                </div>
                <div class="row">
                    <div class="col-6">
                        <label class="font-weight-bold">Street:</label>
                    </div>
                    <div class="col">
                        <span class="d-inline-block mw-100">{{ customerEnquiry.street }}</span>
                    </div>
                </div>
                <div class="row">
                    <div class="col-6">
                        <label class="font-weight-bold">District:</label>
                    </div>
                    <div class="col">
                        <span class="d-inline-block mw-100">{{ customerEnquiry.district }}</span>
                    </div>
                </div>
                <div class="row">
                    <div class="col-6">
                        <label class="font-weight-bold">City:</label>
                    </div>
                    <div class="col">
                        <span class="d-inline-block mw-100">{{ customerEnquiry.city }}</span>
                    </div>
                </div>
                <div class="row">
                    <div class="col-6">
                        <label class="font-weight-bold">Province:</label>
                    </div>
                    <div class="col">
                        <span class="d-inline-block mw-100">{{ customerEnquiry.province }}</span>
                    </div>
                </div>
                <div class="row">
                    <div class="col-6">
                        <label class="font-weight-bold">Postal Code:</label>
                    </div>
                    <div class="col">
                        <span class="d-inline-block mw-100">{{ customerEnquiry.postal_code }}</span>
                    </div>
                </div>
                <div class="row">
                    <div class="col-6">
                        <label class="font-weight-bold">Additional Address Details:</label>
                    </div>
                    <div class="col">
                        <span class="d-inline-block mw-100">{{ customerEnquiry.additional_address_details || 'N/A' }}</span>
                    </div>
                </div>
                <div class="row">
                    <div class="col-6">
                        <label class="font-weight-bold">Length of Residence:</label>
                    </div>
                    <div class="col">
                        <span class="d-inline-block mw-100">{{ customerEnquiry.length_of_residence }}</span>
                    </div>
                </div>
            </div>
        </div>
        <div slot="modal-footer">
            <b-button
                variant="primary"
                @click="$refs.modal.hide()"
                >
                Close
            </b-button>
        </div>
    </b-modal>
</template>

<script>
import AvatarIcon from "@/components/main/icons/AvatarIcon";
import Roles from "@/constants/roles";

export default {
    components: {
        AvatarIcon,
    },
    props: {
        customerEnquiry: {
            required: true,
            type: Object,
        },
    },
    methods: {
        show() {
            this.$refs.modal.show();
        },
        hide() {
            this.$refs.modal.hide();
        },
    },
    computed: {
        salesManagerUsers() {
            return this.enquiryHandlers
        },
    },
}
</script>
<style scoped>
.underline {
  text-decoration: underline;
}
.logo-image {
  width: 75px;
  height: 75px;
  object-fit: cover;
}
 .email-span {
  overflow-wrap: break-word;
  word-wrap: break-word;
  word-break: break-word;
 }
</style>
